module.exports = __webpack_public_path__ + "media/images/lp/1/achievement6-pc-f8df3531096c11143a8ac41a88026374.png";